// extracted by mini-css-extract-plugin
module.exports = {"mining":"mining_mining__Vgtsd","circle":"mining_circle__1joPb","ifFalse":"mining_ifFalse__JFEYt","ifTrue":"mining_ifTrue__VTErZ"};